import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export interface ITrackAmplitudeOpenGalleryParams {
    location?: string;
    offerId: number | string;
    propertyId?: number;
    galleryView: "grid" | "viewer" | "map" | "gated";
    photoSection: "gallery" | "construction_photos" | "floor_plan" | "map";
    mediaTabNavigation?: "initial" | "tab_switch";
    photosTotal?: number;
    photoIndex?: number;
    contentAccess?: "full" | "gated";
}

export const trackAmplitudeOpenGallery = (params: ITrackAmplitudeOpenGalleryParams & {location: string}) => {
    const {location, offerId, propertyId, galleryView, photoSection, mediaTabNavigation, photosTotal, photoIndex, contentAccess} = params;

    const eventProperties: Record<string, string | number | null> = {
        location,
        item_id: offerId,
        gallery_view: galleryView,
        photo_section: photoSection,
        property_id: propertyId ?? null
    };

    if (mediaTabNavigation != null) {
        eventProperties.media_tab_navigation = mediaTabNavigation;
    }
    if (photosTotal != null) {
        eventProperties.photos_total = photosTotal;
    }
    if (photoIndex != null) {
        eventProperties.photo_index = photoIndex;
    }
    if (contentAccess != null) {
        eventProperties.content_access = contentAccess;
    }

    trackAmplitudeEvent("open_gallery", eventProperties);
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export interface ITrackAmplitudeOpenGalleryParams {
    location?: string;
    offerId: number | string;
    propertyId?: number;
    galleryView: "grid" | "viewer" | "map" | "gated";
    photoSection: "gallery" | "construction_photos" | "floor_plan" | "map";
    mediaTabNavigation?: "initial" | "tab_switch";
    photosTotal?: number;
    photoIndex?: number;
    contentAccess?: "full" | "gated";
}

export const trackAmplitudeOpenGallery = (params: ITrackAmplitudeOpenGalleryParams & {location: string}) => {
    const {location, offerId, propertyId, galleryView, photoSection, mediaTabNavigation, photosTotal, photoIndex, contentAccess} = params;

    const eventProperties: Record<string, string | number | null> = {
        location,
        item_id: offerId,
        gallery_view: galleryView,
        photo_section: photoSection,
        property_id: propertyId ?? null
    };

    if (mediaTabNavigation != null) {
        eventProperties.media_tab_navigation = mediaTabNavigation;
    }
    if (photosTotal != null) {
        eventProperties.photos_total = photosTotal;
    }
    if (photoIndex != null) {
        eventProperties.photo_index = photoIndex;
    }
    if (contentAccess != null) {
        eventProperties.content_access = contentAccess;
    }

    trackAmplitudeEvent("open_gallery", eventProperties);
};
